import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable()
export class AccessControlInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (environment.production) {
      const tokenEl = document.getElementById('__RequestVerificationToken') as HTMLInputElement | null;
      console.log('[AccessControl] __RequestVerificationToken element:', tokenEl ? 'found' : 'NOT FOUND');
      console.log('[AccessControl] token value:', tokenEl?.value ? 'present' : 'empty');
      if (tokenEl?.value) {
        request = request.clone({
          setHeaders: { 'RequestVerificationToken': tokenEl.value }
        });
      }

      const clientCtx = document.getElementById('__ClientContext') as HTMLInputElement | null;
      console.log('[AccessControl] __ClientContext element:', clientCtx ? 'found' : 'NOT FOUND');
    }
    return next.handle(request);
  }
}
